import $ from "jquery";

let Kits;

let loading_markup;
let noun_user;
let url_to_array;

loading_markup =
    '<div class="loading clearfix"><div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div><div class="dot dot4"></div></div>';

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

Kits = (() => {
    function Kits() {
        let cardListeners;
        let closeCustomName;
        let closeKit;
        let hideAndRemove;
        let toggleLocked;
        let togglePublic;
        $("body").on("click", "#kit-container", e => e.stopPropagation());
        $("body").on("click", ".new-custom-name", e => e.stopPropagation());
        if (typeof String.prototype.trim === "undefined") {
            String.prototype.trim = function() {
                return String(this).replace(/^\s+|\s+$/g, "");
            };
        }
        $.fn.serializeObject = function() {
            let a;
            let o;
            o = {};
            a = this.serializeArray();
            $.each(a, function() {
                if (o[this.name] !== undefined) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || "");
                } else {
                    o[this.name] = this.value || "";
                }
            });
            return o;
        };

        closeKit = e => {
            let visibleKit;
            visibleKit = $(".kit-container.visible");
            if (visibleKit.length > 0) {
                visibleKit.removeClass("visible");
                $("body").removeClass("kit-open");
                $(".container.kit-open").removeClass("kit-open");
                $("a.kit")
                    .addClass("ui_kit")
                    .removeClass("ui_kit-open", "ajaxing");
                return setTimeout(() => {
                    visibleKit.find("form").remove();
                    return visibleKit.find("li").remove();
                }, 500);
            }
        };
        $(".create-new-kit").on("click", function(e) {
            e.preventDefault();
            $("form#create-new-kit span.message").hide();
            return $("form#create-new-kit").addClass("visible");
        });
        cardListeners = () => {
            $(".card a.card-information").on("click", function(e) {
                let parent;
                e.preventDefault();
                parent = $(this).parents(".card");
                parent.find("form.edit-kit-form").hide();
                parent.find(".delete-confirmation").hide();
                parent.find(".description").show();
                return parent.toggleClass("flip");
            });
            $(".card a.edit-kit-info").on("click", function(e) {
                let deny;
                let parent;
                e.preventDefault();
                parent = $(this).parents(".card");
                parent.toggleClass("flip");
                parent.find(".description").hide();
                parent.find(".delete-confirmation").hide();
                parent.find("form").show();
                deny = parent.find(".deny-edit-kit");
                return deny.on("click", function(e) {
                    e.preventDefault();
                    $(this).removeClass("loading");
                    parent.removeClass("flip");
                    return setTimeout(() => {
                        parent.find("form.edit-kit-form").hide();
                        return parent.find(".description").show();
                    }, 500);
                });
            });
            $("footer a.delete-kit").on("click", function(e) {
                let confirm;
                let deny;
                let parent;
                e.preventDefault();
                parent = $(this).parents(".card");
                parent.addClass("flip");
                parent.find(".delete-confirmation").show();
                parent.find(".description").hide();
                confirm = parent.find(".confirm-delete-kit");
                deny = parent.find(".deny-delete-kit");
                confirm.on("click", () => {
                    e.preventDefault;
                    return $.ajax({
                        url: e.target.href,
                        method: "POST",
                        success(data, status, xhr) {
                            console.log(data);
                            return hideAndRemove(parent);
                        },
                        error(xhr, textStatus, errorThrown) {
                            console.log("error!", xhr);
                            return $(this).removeClass("loading");
                        }
                    });
                });
                return deny.on("click", function(e) {
                    $(this).removeClass("loading");
                    parent.removeClass("flip");
                    parent.find(".delete-confirmation").hide();
                    return parent.find(".description").show();
                });
            });
            $("footer a.publicize-kit").on("click", function(e) {
                let el;
                e.preventDefault();
                el = this;
                $(this).addClass("loading");
                return $.ajax({
                    url: e.target.href,
                    method: "POST",
                    success(data, status, xhr) {
                        console.log(data);
                        return togglePublic(el);
                    },
                    error(xhr, textStatus, errorThrown) {
                        console.log("error!", xhr);
                        return $(el).removeClass("loading");
                    }
                });
            });
            return $("footer a.lock-kit").on("click", function(e) {
                let el;
                e.preventDefault();
                el = this;
                $(this).addClass("loading");
                return $.ajax({
                    url: e.target.href,
                    method: "POST",
                    success(data, status, xhr) {
                        console.log(data);
                        return toggleLocked(el);
                    },
                    error(xhr, textStatus, errorThrown) {
                        console.log("error!", xhr);
                        return $(el).removeClass("loading");
                    }
                });
            });
        };
        cardListeners();
        $("body").on("click", ".term .ui_pencil", function(e) {
            let $this;
            let parent;
            e.preventDefault();
            $this = $(this);
            e.stopPropagation();
            $("html").one("click", e => closeCustomName($this));
            parent = $this.parents("footer");
            parent.find(".term").hide();
            parent.find("form").show();
            return parent.find("input").trigger("focus");
        });
        closeCustomName = obj => {
            let $this;
            let parent;
            $this = obj;
            parent = $this.parents("footer");
            parent.find(".term").show();
            return parent.find("form").hide();
        };
        $("body").on("submit", "form.new-custom-name", function(e) {
            let $form;
            let $saveButton;
            let data;
            e.preventDefault();
            console.log("e is", e);
            data = $(this).serializeObject();
            $form = $(this);
            $saveButton = $form.find("button");
            $saveButton.removeClass("ui_save");
            $saveButton.addClass("loading");
            return $.ajax({
                url: e.target.action,
                method: "POST",
                data,
                success(data, status, xhr) {
                    console.log(data);
                    $saveButton.removeClass("loading");
                    $saveButton.addClass("ui_save");
                    $form.hide();
                    $form
                        .parent()
                        .find(".term")
                        .show();
                    $form
                        .parent()
                        .find(".term small.term-name")
                        .removeClass("hidden");
                    return $form
                        .parent()
                        .find(".kiticon-name")
                        .text(data);
                },
                error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        $(document).on("kit:create", function(e, data) {
            let { id: kitId } = data;
            if (!kitId) {
                console.warn("no kit id");
                return;
            }
            return $.ajax({
                url: `/kit/card/${kitId}`,
                method: "GET",
                success(data, status, xhr) {
                    $(data).insertBefore($("#new-kit-card"));
                    return cardListeners();
                }
            });
        });

        $("body").on("click", "a.kit.delete-icon", function(e) {
            let that;
            e.preventDefault();
            $(this).addClass("loading");
            that = this;
            return $.ajax({
                url: e.target.href,
                method: "POST",
                success(data, status, xhr) {
                    $(that).removeClass("loading");
                    $(that)
                        .parent()
                        .addClass("deleting");
                    $(that)
                        .parent()
                        .hide(500);
                    return setTimeout(
                        () =>
                            $(that)
                                .parent()
                                .remove(),
                        500
                    );
                },
                error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        $("form.edit-kit-form").on("submit", function(e) {
            let $form;
            let $saveButton;
            let data;
            let parent;
            e.preventDefault();
            data = $(this).serializeObject();
            $form = $(this);
            parent = $(this).parents(".card");
            $saveButton = $form.find("button.confirm-edit-kit");
            $saveButton.addClass("loading");
            return $.ajax({
                url: e.target.action,
                method: "POST",
                data,
                success(data, status, xhr) {
                    let shortName;
                    console.log(data);
                    $saveButton.removeClass("loading");
                    parent.removeClass("flip");
                    parent
                        .find(".description")
                        .text(data.description)
                        .show();
                    if (data.name.length > 20) {
                        shortName = `${data.name.substring(0, 20)}…`;
                    } else {
                        shortName = data.name;
                    }
                    parent
                        .find(".front span.name")
                        .text(shortName)
                        .attr("title", data.name);
                    parent.find("a.permalink").attr("href", data.permalink);
                    return $form.hide();
                },
                error(xhr, textStatus, errorThrown) {
                    return console.log("error!", xhr);
                }
            });
        });
        hideAndRemove = el => $(el).hide(500, () => $(el).remove());
        toggleLocked = el => {
            $(el).removeClass("loading");
            $(el).toggleClass("ui_lock");
            $(el).toggleClass("ui_unlock");
            if ($(el).hasClass("ui_lock")) {
                return $(el).attr("title", "Locked");
            } else {
                return $(el).attr("title", "Unlocked");
            }
        };
        togglePublic = el => {
            $(el).removeClass("loading");
            $(el).toggleClass("ui_eye");
            $(el).toggleClass("ui_eye-off");
            if ($(el).hasClass("ui_eye")) {
                $(el).attr("title", "Public");
                return $(el)
                    .siblings(".share")
                    .removeClass("hide");
            } else {
                $(el).attr("title", "Private");
                return $(el)
                    .siblings(".share")
                    .addClass("hide");
            }
        };
    }

    return Kits;
})();

export default Kits;
